export default __webpack_public_path__ + "static/media/030_corner1_01.a75ef472.mp3";